export const UNPAID_LEAVE_PREVIEW_PATH = '/common/vacations/me/unpaid-preview';
export const UNPAID_LIMIT_MIN = 0;
export const UNPAID_LIMIT_MAX = 31;
export const UNPAID_LIMIT_FIELDS = [
  {key: 'unpaidSingleDayLimit', label: 'UNPAID_SINGLE_LIMIT'},
  {key: 'unpaidMultiDayLimit', label: 'UNPAID_MULTI_LIMIT'},
  {key: 'unpaidMonthlyDayLimit', label: 'UNPAID_DAYS_LIMIT'}
];
export const UNPAID_ERROR_KEYS: {[code: string]: string} = {
  UNPAID_SINGLE_DAY_LIMIT_EXCEEDED: 'UNPAID_SINGLE_EXCEEDED',
  UNPAID_MULTI_DAY_LIMIT_EXCEEDED: 'UNPAID_MULTI_EXCEEDED',
  UNPAID_MONTHLY_DAY_LIMIT_EXCEEDED: 'UNPAID_DAYS_EXCEEDED',
  VACATION_DATE_INVALID: 'VACATION_ERROR_DATE_INVALID',
  UNPAID_NO_WORKING_DAYS: 'UNPAID_NO_WORKING_DAYS',
  UNPAID_SCHEDULE_UNAVAILABLE: 'UNPAID_SCHEDULE_UNAVAILABLE'
};
export const UNPAID_PREVIEW_ERROR = 'UNPAID_PREVIEW_ERROR';
export const UNPAID_EMPTY = '';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/vacation/unpaid-leave.constants.ts